import React, { useEffect, useState } from "react";
import { useObjectStore } from "../zustand/objects";
import { IconShare } from '@tabler/icons-react';
import ShareModal from './ShareModal';
import StoryboardToolbarIcon from "./StoryboardToolbarIcon";
import EditorToolbarIcon from "./EditorToolbarIcon";
import { CHROME_TOOLBAR_ICON_GLYPH } from "../utils/editorChromeTheme";

const SharePreviewButton = ({ projectKey, iconColour, framed = false, inGroup = false }) => {

  const {
    switchShareModalOpen
  } = useObjectStore();

  const [, setShow] = useState(false);
  const [, setShowText] = useState(false);
  const [, setDivWidth] = useState(50);

  useEffect(() => {
    setDivWidth(60)
  })

  if (framed) {
    return (
      <>
        <StoryboardToolbarIcon label="Configure sharing" onClick={() => switchShareModalOpen()}>
          <IconShare size={CHROME_TOOLBAR_ICON_GLYPH} />
        </StoryboardToolbarIcon>
        <ShareModal projectKey={projectKey} />
      </>
    );
  }

  return (<>
    <EditorToolbarIcon
      label="Configure sharing"
      onClick={() => switchShareModalOpen()}
      iconColour={iconColour}
      inGroup={inGroup}
    >
      <IconShare size={CHROME_TOOLBAR_ICON_GLYPH} />
    </EditorToolbarIcon>

    <ShareModal projectKey={projectKey} />
</>
  );
};

export default SharePreviewButton;
